import Lookup from 'src/componentes/select2';

const TipoLinhaGrafico = (props) => (
  <Lookup
    clearable={false}
    labelKey="descricao"
    valueKey="id"
    url="/TipoLinhaGraficoLookup"
    {...props}
  />
);

export default TipoLinhaGrafico;
